import { createEventSource } from '../eventSource';
import { server } from '../server';
export const getAgents = async (chainLayer, first = 50, skip = 0, isGraduated = [true, false], sortBy = 'market_cap', sortDirection = 'desc') => {
    const page = Math.floor(skip / first);
    const size = first;
    const queryParams = new URLSearchParams({
        page: page.toString(),
        size: size.toString(),
        is_graduated: isGraduated.join(','),
        sort_by: sortBy,
        sort_direction: sortDirection,
    });
    const response = await server.get({
        endpoint: 'agents',
        queryParams,
        chainLayer,
    });
    if (!response.ok) {
        throw new Error(`Error fetching agents: ${response.statusText}`);
    }
    const data = await response.json();
    return data;
};
/**
 * @param address can be a bonding address or agent address
 * @returns info about the given agent
 */
export const getAgent = async (chainLayer, address) => {
    const response = await server.get({
        endpoint: `agent/${address}`,
        chainLayer,
    });
    if (!response.ok) {
        throw new Error(`Error fetching agent with id ${address}: ${response.statusText}`);
    }
    const data = await response.json();
    return data;
};
/**
 * @param bondingTokenAddress bonding token address
 * @returns EventSource
 */
export const getAgentMessagesEventSource = (chainLayer, bondingTokenAddress) => {
    return createEventSource({
        endpoint: `agent/${bondingTokenAddress}/messages/streaming`,
        chainLayer,
    });
};
export const createAgentMessage = async (chainLayer, walletAddress, bondingTokenAddress, text) => {
    const response = await server.post({
        endpoint: `agent/${bondingTokenAddress}/message`,
        chainLayer,
    }, {
        body: JSON.stringify({ text }),
        headers: {
            'Content-Type': 'application/json',
        },
        needAuthentication: true,
        walletAddress,
    });
    if (!response.ok) {
        throw new Error(`Error creating agent message: ${response.statusText}`);
    }
};
export const updateAgent = async (chainLayer, walletAddress, tokenAddress, data) => {
    const response = await server.put({
        endpoint: `agent/${tokenAddress}`,
        chainLayer,
    }, {
        body: JSON.stringify(data),
        headers: {
            'Content-Type': 'application/json',
        },
        needAuthentication: true,
        walletAddress,
    });
    if (!response.ok) {
        let resBody = '';
        try {
            resBody = await response.text();
        }
        catch (e) {
            // do nothing
        }
        throw new Error(`Error updating agent: ${response.status} ${response.statusText} ${resBody}`);
    }
    const responseData = await response.json();
    return responseData;
};
export const getCanUpdateAgent = async (chainLayer, walletAddress, tokenAddress) => {
    const response = await server.get({
        endpoint: `agent/${tokenAddress}/validate-revision`,
        chainLayer,
    }, {
        headers: {
            'Content-Type': 'application/json',
        },
        needAuthentication: true,
        walletAddress,
    });
    if (!response.ok) {
        throw new Error(`Error validating agent revision: ${response.statusText}`);
    }
    return response.ok;
};
